
// From whatwg-fetch. See https://www.npmjs.com/package/whatwg-fetch#handling-http-error-statuses
export const checkStatus = response => {
  if(response.ok) {
    return response
  } else {
    const error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

// Generates header value for Authorization with "Basic" authentication scheme.
// See https://developer.mozilla.org/en-US/docs/Web/HTTP/Authentication
export const generateBasicAuthHeaderValue = (username, password) => {
  return `Basic ${btoa(`${username}:${password}`)}`
}

// Wrapper for fetch with support for timeouts.
export const fetchWithTimeout = (url, opts, timeout = 5000) => {
  return Promise.race([
    fetch(url, opts),
    new Promise((resolve, reject) => setTimeout(reject, timeout))
  ])
}

// Get object from storage // Parse stringified JSON from session storage
export const fetchObjectFromStorage = key => {
  const obj = sessionStorage.getItem(key)

  return obj && JSON.parse(obj)
}

// Set object as stringified JSON in session storage
export const setObjectInStorage = (key, obj) => {
  sessionStorage.setItem(key, JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/api/utils.js